import React, { useEffect, useRef } from "react"
import { navigate } from "gatsby"
import { useLocation } from "@gatsbyjs/reach-router"
import { ScrollTrigger } from "gsap/ScrollTrigger"

export default function PageTransition({ children }) {
    const ref = useRef(null)
    const { pathname } = useLocation()

    useEffect(() => {
        const wrapper = ref.current
        if (!wrapper) return

        const normalise = path => {
            try {
                return new URL(path, window.location.origin).pathname.replace(/\/$/, "") || "/"
            } catch {
                return ""
            }
        }

        const fadeOut = (event, path) => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return
            event.preventDefault()
            if (normalise(pathname) === normalise(path)) return
            wrapper.classList.remove("fade--in")
            wrapper.classList.add("fade--out")
            document.body.classList.remove('menu-open')
            setTimeout(() => navigate(path), 350)
        }

        wrapper.classList.remove("fade--out")
        wrapper.classList.add("fade--in")
        ScrollTrigger.refresh()

        const links = document.querySelectorAll("a")
        const handlers = []
        links.forEach(link => {
            if (link.hasAttribute("target")) return
            const path = link.getAttribute("href")
            if (!path || !path.startsWith("/") || path.startsWith("//")) return
            const handler = event => fadeOut(event, path)
            link.addEventListener("click", handler)
            handlers.push([link, handler])
        })
        return () => handlers.forEach(([link, handler]) => link.removeEventListener("click", handler))
    }, [pathname])

    return (
        <div ref={ref} className='page--transition fade--in'>
            {children}
        </div>
    )
}
